//src/services/homepage.api.js
import { apiRequest } from "./api";

export const getHomepageCategoryCards = () =>
  apiRequest("/homepage/category-cards");

export const getHomepageLuxuryVideos = () =>
  apiRequest("/homepage/luxury-videos");

export const getHomepageCategoryHero = () =>
  apiRequest("/homepage/category-hero");

export const getHomepageFeaturedCategories = () =>
  apiRequest("/homepage/featured-categories");

  export const getHomepagePopularSearchOrder = () =>
  apiRequest("/homepage/popular-search-order");

export const getHomepageAccessoriesSection = () =>
  apiRequest("/homepage/accessories-section");

export const getHomepageFlatsMiniSection = () =>
  apiRequest("/homepage/flats-mini-section");
